module.exports = __webpack_public_path__ + "fonts/MuseoSlab-500.24bc9247.woff";